import { Box, Typography, Container, Paper, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import { PlayArrow, VolumeUp, VolumeOff } from '@mui/icons-material';
import { useState, useRef } from 'react';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleMuteToggle = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <Box sx={{ py: 15, background: '#111' }}>
      <Container maxWidth="lg">
        <Typography
          variant="subtitle1"
          sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2, textAlign: 'center' }}
        >
          WELCOME MESSAGE
        </Typography>

        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            mb: 4,
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          A Message From John Asfar
        </Typography>

        <Typography
          sx={{
            textAlign: 'center',
            maxWidth: '700px',
            mx: 'auto',
            color: '#ccc',
            mb: 6,
          }}
        >
          Watch this personal message about direct access, global leadership, and our shared vision.
        </Typography>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          <Paper
            sx={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 4,
              cursor: 'pointer',
            }}
          >
            <video
              ref={videoRef}
              poster="/videos/poster.jpg"
              style={{ width: '100%', display: 'block' }}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              muted={isMuted}
            >
              <source src="/videos/executive-message.mp4" type="video/mp4" />
            </video>

            {!isPlaying && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 2,
                }}
              >
                <IconButton
                  onClick={handlePlayPause}
                  sx={{
                    background: 'rgba(0,0,0,0.7)',
                    width: 80,
                    height: 80,
                    '&:hover': {
                      background: '#C8A96B',
                      '& svg': { color: '#000' },
                    },
                  }}
                >
                  <PlayArrow sx={{ fontSize: 50, color: '#C8A96B' }} />
                </IconButton>
              </Box>
            )}

            <IconButton
              onClick={handleMuteToggle}
              sx={{
                position: 'absolute',
                bottom: 20,
                right: 20,
                background: 'rgba(0,0,0,0.5)',
                '&:hover': { background: 'rgba(0,0,0,0.8)' },
              }}
            >
              {isMuted ? <VolumeOff /> : <VolumeUp />}
            </IconButton>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default VideoSection;